import { CURRENT_PURPOSE, WEBSITE_FARM_TRADE } from "./website-config";

const RealEstate = [
  {
    name: "My workspace",
    url: "/my-list",
    enableAuthentication: true,
  },
  {
    name: "Marketplace",
    url: "/marketplace",
  },
  {
    name: "Transaction Explorer",
    url: "/transaction-explorer",
  },
  {
    name: "Verto GPT",
    url: "/gpt",
  },
  {
    name: "EUDR Reports",
    url: "/eudr-reports",
    enableAuthentication: true,
  },
];

export const MobileMenuConfig = [
  {
    name: "Home",
    url: "/",
    enableAuthentication: true,
  },
  {
    name: "My workspace",
    url: "/my-list",
    enableAuthentication: true,
  },
  {
    name: "Marketplace",
    url: "/marketplace",
  },
  {
    name: "Transaction Explorer",
    url: "/transaction-explorer",
  },
  {
    name: "Verto GPT",
    url: "/gpt",
  },
  {
    name: "EUDR Reports",
    url: "/eudr-reports",
    enableAuthentication: true,
  },
];

export const MenuConfig = RealEstate;